import { IApplicationState } from '../../../../../../../../types/types';
import {
    savedFilterSelector
} from '../../../../../../aside_panel/filterPanelBoard/store/selectors/savedFilterSelector';
import {
    getPinnedSavedFiltersIds
} from '../../../../../../aside_panel/filterPanelBoard/components/SavedSection/hocs/selectors/getPinnedSavedFiltersIds';
import { MY_WORK_FILTER_BOARD_ID } from '../../../../../../aside_panel/filterPanelBoard/constants';

export const getAllFiltersUnselected = (
    state: IApplicationState
) => {
    let isAllFiltersUnselected = true;
    const filterIds = getPinnedSavedFiltersIds(state, MY_WORK_FILTER_BOARD_ID);
    for (let i = 0; i < filterIds.length; i++) {
        const { isEnabled } = savedFilterSelector(state, filterIds[i]);
        if (isEnabled) {
            isAllFiltersUnselected = false;
            return;
        }
    }
    return isAllFiltersUnselected;
}
